import { SIDEBAR_SET } from "../const";
import { ISidebarItem } from "../components/Routes";

export const setSidebar = (position: ISidebarItem) => {
  return {
    type: SIDEBAR_SET,
    payload: { position },
  };
};
